module.exports = new __parcel__URL__("Archerskill_47.4b85b449.png").toString();